// src/services/socket.js
// Point d'entrée unique pour la connexion Socket.IO authentifiée : une seule
// connexion partagée pour toute la session (au lieu d'une par page), pour
// pouvoir suivre des évènements temps réel (messages non lus, notifications)
// même sur des écrans qui ne sont pas /chat. Le backend rejette toute
// connexion sans JWT valide dans le handshake (voir
// notifications-realtime-contract.md).
import { io } from 'socket.io-client';
import { API_HOST } from './api';
import { getToken, getUserIdFromToken } from './authService';

let socket = null;

export function getSocket() {
    if (socket) return socket;

    socket = io(API_HOST, {
        auth: { token: getToken() },
    });

    socket.on('connect_error', (err) => {
        console.error('Connexion WebSocket refusée :', err.message);
    });

    // Rejoint systématiquement sa propre room à chaque (re)connexion (y compris
    // après une coupure réseau), pour ne jamais perdre la réception des events.
    socket.on('connect', () => {
        try {
            socket.emit('join_room', getUserIdFromToken());
        } catch (err) {
            console.error('Impossible de rejoindre la room utilisateur :', err.message);
        }
    });

    return socket;
}

// À appeler uniquement à la déconnexion de l'utilisateur (logout) : la socket
// est partagée entre plusieurs écrans, elle ne doit pas être fermée quand un
// seul composant qui l'utilise est démonté.
export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
